module.exports = __webpack_public_path__ + "img/Anhänger_6t.1550badc.svg";